<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover" />
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                containerForm: () => import('../forms/ContainerForm'),
                fileForm: () => import('../forms/FileForm'),
                fields: [
                    { type: 'autocomplete', text: 'Container', value: 'containerId', rules: [v => !!v || 'Container is required'], isRequired: true, form: () => import('./ContainerForm'), apiMethod: 'Containers', claim: 'Containers' },
                    { type: 'file', text: 'File', value: 'fileId', rules: [v => !!v || 'File is required'], isRequired: true, form: () => import('./FileForm'), apiMethod: 'Files' },
                ],
                apiMethod: 'ContainerFiles',
                formTitle: 'Container File',
            }
        },
    };
</script>
